export default __webpack_public_path__ + "static/bg_image_other@2x-eb5d0f9799b9d16a1bf2f39935c72334.webp";